import { NgModule } from "@angular/core";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import {
  AppLoaderInterceptor,
  CacheInterceptor,
  ConvertParamsToUrlInterceptor,
  ErrorsModule,
  MfaModule,
  OAuthInterceptor,
  OAuthService,
  RefreshTokenInterceptor,
  UserMessagesModule,
  EntityProvider,
} from "common";
import { CoreModule } from "./core/core.module";
import { DashboardModule } from "./features/dashboard/dashboard.module";
import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { AuthService } from "./features/auth/infrastructure/auth.service";
import { AuthModule } from "./features/auth/auth.module";
import { SharedModule } from "./shared/shared.module";
import { ApplicationFormModule } from "./features/application-form/application-form.module";
import { RedirectionModule } from "./features/redirection/redirection.module";
import { IdentityVerificationModule } from "./features/identity-verification/identity-verification.module";
import { MyEntityProvider } from "./core/adapters/my-entity.provider";

@NgModule({
  declarations: [AppComponent],
  imports: [
    AppRoutingModule,
    SharedModule,
    CoreModule,
    DashboardModule,
    AuthModule,
    ApplicationFormModule,
    IdentityVerificationModule,
    MfaModule,
    RedirectionModule,
    UserMessagesModule,
    ErrorsModule
  ],
  providers: [
    {
      provide: HTTP_INTERCEPTORS,
      useClass: RefreshTokenInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: OAuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: AppLoaderInterceptor, multi: true },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConvertParamsToUrlInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: CacheInterceptor, multi: true },
    {
      provide: OAuthService,
      useClass: AuthService,
    },
    {
      provide: EntityProvider,
      useClass: MyEntityProvider,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  constructor() { }
}
